window.addEventListener('load', event => {
    // Mobile Menu JS
    let keyboardMenuOpen = document.getElementById('skip-to-navigation');
    if (keyboardMenuOpen) {
        keyboardMenuOpen.addEventListener('click', function() {
            document.getElementById('mobileMenu').classList.remove('hidden');
            setTimeout(function() {
                document.getElementById('mobileMenu').classList.remove('opacity-0');
                document.getElementById('mobileMenu').classList.add('active');
                document.body.classList.add('mobile-lock-scroll');
            }, 150);

            document.getElementById('menuHomeButton').focus();
        });
    }

    let mobileMenuOpen = document.getElementById('mobileMenuOpen');
    if (mobileMenuOpen) {
        mobileMenuOpen.addEventListener('click', function() {
            document.getElementById('mobileMenu').classList.remove('hidden');
            setTimeout(function() {
                document.getElementById('mobileMenu').classList.remove('opacity-0');
                document.getElementById('mobileMenu').classList.add('active');
                document.body.classList.add('mobile-lock-scroll');
            }, 150);

            if (this.classList.contains('focus-visible')) {
                document.getElementById('menuHomeButton').focus();
            }
        });
    }

    let scrollnavopen = document.getElementById('scrollNavOpen');
    if (scrollnavopen) {
        scrollnavopen.addEventListener('click', function() {
            document.getElementById('mobileMenu').classList.remove('hidden', 'md:!hidden');
            setTimeout(function() {
                document.getElementById('mobileMenu').classList.remove('opacity-0');
                document.getElementById('mobileMenu').classList.add('active');
                document.body.classList.add('mobile-lock-scroll');
            }, 150);

            if (this.classList.contains('focus-visible')) {
                document.getElementById('menuHomeButton').focus();
            }
        });
    }

    let mobileMenuClose = document.getElementById('mobileMenuClose');
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function() {
            document.body.classList.remove('mobile-lock-scroll');
            document.getElementById('mobileMenu').classList.add('opacity-0');
            setTimeout(function() {
                document.getElementById('mobileMenu').classList.add('hidden', 'md:!hidden');
                document.getElementById('mobileMenu').classList.remove('active');
            }, 150);

            if (this.classList.contains('focus-visible')) {
                document.getElementById('homeButton').focus();
            }
        });
    }
});
